
import { defineComponent } from 'vue'
import { Chart } from 'highcharts-vue'

export default defineComponent({
  components: {
    highcharts: Chart,
  },
  props: {
    data: {
      required: true,
      type: Object as any,
    },
  },
  setup(props) {
    const chartOptions = {
      chart: {
        type: 'column',
      },
      title: {
        text: props.data.series[0].name,
      },
      xAxis: {
        categories: props.data.categories,
        title: {
          text: null,
        },
        gridLineWidth: 0.9,
        lineWidth: 0,
        labels: {
          textOverflow: 'ellipsis',
          textAlign: 'left',
          width: '100px',
          align: 'center',
          reserveSpace: true,
          overflow: 'justify',
          rotation: 0,
        },
      },
      yAxis: {
        min: 0,
        title: {
          text: '',
          align: 'high',
        },
        labels: {
          overflow: 'justify',
        },
        gridLineWidth: 0,
      },
      legend: {
        reversed: true,
      },
      credits: {
        enabled: false,
      },
      plotOptions: {
        bar: {
          dataLabels: {
            enabled: false,
          },
          groupPadding: 10,
        },
      },
      series: props.data.series,
    }
    return { chartOptions }
  },
})
